/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
} from "react-icons/md";
import { AiFillContainer, AiTwotoneBank } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
// import Gravatar from "react-gravatar";
import logo from "assets/logo/logo.png";
import fav from "assets/icons/user2.png";
import styled from "styled-components";
import { AuthContext } from "../context/Auth";
import { PageLoader } from "../components/Loaders";
import Sidebar from "../components/Sidebar";
import Select from "../components/form/Select";
import Input from "../components/form/Input";
import { BsBell } from "react-icons/bs";
import Header from "../components/Header";

const DashboardPlate = styled.div`
  padding: 30px 50px;
  ${"" /* margin: 40px 40px 20px; */}
  ${"" /* background: #fff; */}
  border: 1px solid transparent;
  ${"" /* min-height: 60vh; */}
`;

export default function DashBoardLayout({ children }) {
  const { signOut, logoutLoading } = React.useContext(AuthContext);

  const [list1, setList1] = useState(false);

  const [list2, setList2] = useState(false);

  const toggleList1 = () => {
    setList1(!list1);
  };

  const toggleList2 = () => {
    setList2(!list2);
  };

  const headerOptions = [
    {
      name: "All Judgements",
    },
  ];

  return (
    <div>
      <div className="app">
        {logoutLoading && <PageLoader />}
        <Sidebar />
        <div className="main">
          <DashboardPlate>
            <Header />
            {children}
          </DashboardPlate>
        </div>
      </div>
    </div>
  );
}
